import { SolanaTransactionInfo } from "@glow/shared";
import classNames from "classnames";
import React from "react";
import { LibraryIcons } from "./LibraryIcon";

export const TransactionCategoryIcon = ({
  type = SolanaTransactionInfo.IconName.Generic,
  display,
  className,
}: {
  type: SolanaTransactionInfo.IconName;
  display: "simple" | "eyebrow" | "big";
  className?: string;
}) => {
  const catIcon =
    LibraryIcons[type] || LibraryIcons[SolanaTransactionInfo.IconName.Generic]!;

  return (
    <div
      className={classNames(
        "category-icon flex",
        display,
        `theme-${catIcon.color}`,
        className,
      )}
    >
      {display === "big" ? catIcon.solid : catIcon.outline}

      <style jsx>{`
        .eyebrow {
          :global(svg) {
            width: 0.875rem;
            height: 0.875rem;
            display: block;
          }
        }

        .big {
          padding: 1rem;
          background-color: var(--brand-pale-bg-color);
          color: var(--brand-color);
          border-radius: 100%;

          :global(svg) {
            width: 2.5rem;
            height: 2.5rem;
            display: block;
          }
        }
      `}</style>
    </div>
  );
};
